let x = 2 in plus2(x)
